function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "icon_focused_stroke",
  d: "M6.5 16C28.4355 16 35.0161 16 40.5 16",
  stroke: "#8AC341",
  strokeWidth: 0,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 10"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon_focused_stroke",
  d: "M34.5 23L41.5 16L34.5 9",
  stroke: "#8AC341",
  strokeWidth: 0,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 10"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d3)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 16,
  r: 8,
  fill: "#007BFF"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon_focused",
  cx: 22,
  cy: 16,
  r: 11,
  stroke: "#8AC341",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 10"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon_selected_stroke6",
  d: "M6.5 16C28.4355 16 35.0161 16 40.5 16",
  stroke: "#373A3C",
  strokeWidth: 0,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "icon_selected_stroke6",
  d: "M34.5 23L41.5 16L34.5 9",
  stroke: "#373A3C",
  strokeWidth: 0,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 16,
  r: 8,
  fill: "#DC3545"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon_selected_stroke2",
  cx: 22,
  cy: 16,
  r: 9,
  stroke: "#373A3C",
  strokeWidth: 0
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 16C28.4355 16 35.0161 16 40.5 16",
  stroke: "#DC3545",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M34.5 23L41.5 16L34.5 9",
  stroke: "#DC3545",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 16,
  r: 8,
  fill: "#DC3545"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "icon_selected_fill_gray",
  d: "M19.9707 17.632C18.7902 17.632 18.2 17.1342 18.2 16.1387C18.2 15.1573 18.7902 14.6667 19.9707 14.6667H23.9813C24.5787 14.6667 25.0196 14.7947 25.304 15.0507C25.6027 15.3067 25.752 15.6693 25.752 16.1387C25.752 16.608 25.6027 16.9778 25.304 17.248C25.0196 17.504 24.5787 17.632 23.9813 17.632H19.9707Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d3",
  x: 4,
  y: 0,
  width: 36,
  height: 36,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 8,
  y: 4,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgNegativeSignalIcon = function SvgNegativeSignalIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    className: "svgIcon",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNegativeSignalIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/negative-signal-icon.0df5c4af.svg";
export { ForwardRef as ReactComponent };